import axios from "axios";

const baseUrl = `${process.env.REACT_APP_BASE_URL}/api`;


export const getBankingInfo = async () => {
    const url = `https://cib-store.vercel.app/api/banking/cie`;

    let result = [];

    await axios.get(url)
    .then((response) => {
        const data = response.data;
        result = { ...data };
    })
    .catch( 
        err => console.log( err )
    );

    return result;
}
